"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = true;
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _objectWithoutPropertiesLoose2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutPropertiesLoose"));

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TreeItem = _interopRequireDefault(require("@material-ui/lab/TreeItem"));

var _Tooltip = _interopRequireDefault(require("../../Tooltip"));

var _styles = _interopRequireDefault(require("../../styles"));

var _tokens = require("../../styles/tokens");

var _useTextOverflow2 = _interopRequireDefault(require("./useTextOverflow"));

var _MasterDetail = require("../MasterDetail");

var _excluded = ["label", "tooltipText"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var styles = function styles(theme) {
  return {
    root: {
      '&:focus > $content $label': {
        backgroundColor: 'unset'
      },
      '&$selected > $content $label': {
        backgroundColor: 'unset'
      },
      '&$selected > $content $label:hover, &$selected:focus > $content $label': {
        backgroundColor: 'unset'
      },
      '&:focus > div': {
        backgroundColor: theme.palette.grey[250],
        boxShadow: _tokens.boxShadowFocusInset
      },
      '&$selected': {
        backgroundColor: 'unset'
      },
      '& > $content:hover, &$selected > $content:hover, &$selected:focus > $content': {
        backgroundColor: theme.palette.grey[250]
      }
    },
    expanded: {},
    selected: {},
    group: {},
    content: {},
    iconContainer: {
      marginRight: _tokens.spacing40,
      marginLeft: "-" + _tokens.spacing10,
      width: '0.125rem' // Don't have size token for 2px

    },
    label: {
      padding: _tokens.spacing30,
      paddingLeft: 0,
      '&:hover': {
        backgroundColor: theme.palette.grey[250]
      }
    }
  };
}; // TreeItem code @material-ui/lab@4.0.0-alpha.46:
// https://github.com/mui-org/material-ui/blob/v4.9.6/packages/material-ui-lab/src/TreeItem/TreeItem.js


var TreeItem = function TreeItem(props) {
  var treeItemRef = (0, _react.useRef)(null);

  var _useTextOverflow = (0, _useTextOverflow2.default)(treeItemRef, "." + _MasterDetail.NODE_LABEL_CLASS),
      overflow = _useTextOverflow[0];

  var label = props.label,
      tooltipText = props.tooltipText,
      rest = (0, _objectWithoutPropertiesLoose2.default)(props, _excluded);

  var newLabel = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, overflow ? /*#__PURE__*/_react.default.createElement(_Tooltip.default, {
    title: tooltipText
  }, label) : label);

  return /*#__PURE__*/_react.default.createElement(_TreeItem.default, (0, _extends2.default)({
    ref: treeItemRef,
    label: newLabel
  }, rest));
};

TreeItem.propTypes = {
  /**
   * The content of the component.
   */
  children: _propTypes.default.node,

  /**
   * Override or extend the styles applied to the component.
   */
  classes: _propTypes.default.object,

  /**
   * @ignore
   */
  className: _propTypes.default.string,

  /**
   * The icon used to collapse the node.
   */
  collapseIcon: _propTypes.default.node,

  /**
   * The icon displayed next to a end node.
   */
  endIcon: _propTypes.default.node,

  /**
   * The icon used to expand the node.
   */
  expandIcon: _propTypes.default.node,

  /**
   * The icon to display next to the tree node's label.
   */
  icon: _propTypes.default.node,

  /**
   * The tree node label.
   */
  label: _propTypes.default.node,

  /**
   * The id of the node.
   */
  nodeId: _propTypes.default.string.isRequired,

  /**
   * @ignore
   */
  onClick: _propTypes.default.func,

  /**
   * @ignore
   */
  onFocus: _propTypes.default.func,

  /**
   * @ignore
   */
  onKeyDown: _propTypes.default.func,

  /**
   * @ignore
   */
  onMouseDown: _propTypes.default.func,

  /**
   * The component used for the transition.
   */
  TransitionComponent: _propTypes.default.elementType,

  /**
   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
   */
  TransitionProps: _propTypes.default.object,

  /**
   * @ignore
   */
  tooltipText: _propTypes.default.string
};
TreeItem.muiName = 'TreeItem';
TreeItem.displayName = 'TreeItem';

var _default = (0, _styles.default)(styles)(TreeItem);

exports.default = _default;